<div class="accordion" [ngClass]="{'opened': isOpened}">
  <button
    class="accordion__header"
    (click)="toggleState(true)"
    [attr.aria-expanded]="isOpened"
    [attr.aria-controls]="'accordion-content-' + id"
    [attr.id]="'accordion-header-' + id"
    type="button">
    <span class="accordion__title">{{title}}</span>
    <span class="accordion__toggle" aria-hidden="true"><brt-icon [icon]="'reg-chevron-down'"></brt-icon></span>
  </button>
  <div
    class="accordion__content-wrapper"
    #contentWrapperEl
    [attr.inert]="isOpened ? null : ''"
    [attr.id]="'accordion-content-' + id"
    [attr.aria-labelledby]="'accordion-header-' + id"
    role="region">
    <div class="accordion__content" #contentEl>
      <ng-content></ng-content>
    </div>
  </div>
</div>
